import React, { useEffect, useState } from "react";
// import axios from "axios";
import axios from "../../../context/axios";
import {
  FaEdit,
  FaTrash,
  FaPlus,
  FaTags,
  FaGlobeAmericas,
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";
import { Dialog } from "@headlessui/react";
import clsx from "clsx";

const TABS = [
  { key: "category", label: "Categories", icon: <FaTags size={18} /> },
  {
    key: "country",
    label: "Regions / Countries",
    icon: <FaGlobeAmericas size={18} />,
  },
];

const ITEMS_PER_PAGE = 5;

const AdminCategoryCountry = () => {
  const [activeTab, setActiveTab] = useState("category");
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  // const [formData, setFormData] = useState({ name: "", image: "" });
  const [formData, setFormData] = useState({ name: "", image: "", order: 0 });

  const [editId, setEditId] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    setPage(1); // reset page on tab change
  }, [activeTab]);

  useEffect(() => {
    fetchData();
  }, [activeTab, page]);

  // const fetchData = async () => {
  //   setIsLoading(true);
  //   setError("");
  //   try {
  //     const res = await axios.get(
  //       `/categories/${activeTab}?page=${page}&limit=${ITEMS_PER_PAGE}`
  //     );
  //     setData(res.data.data);
  //     setTotalPages(res.data.totalPages);
  //   } catch (err) {
  //     setError("Failed to load data.");
  //     console.error(err);
  //   }
  //   setIsLoading(false);
  // };

  const fetchData = async () => {
    setIsLoading(true);
    setError("");
    try {
      const endpoint =
        activeTab === "region"
          ? `/categories/regions?page=${page}&limit=${ITEMS_PER_PAGE}`
          : `/categories/${activeTab}?page=${page}&limit=${ITEMS_PER_PAGE}`;
      const res = await axios.get(endpoint);
      setData(res.data.data);
      setTotalPages(res.data.totalPages);
    } catch (err) {
      setError("Failed to load data.");
      console.error(err);
    }
    setIsLoading(false);
  };

  const handleDelete = async (id) => {
    // if (!window.confirm("Are you sure you want to delete this item?")) return;
    try {
      await axios.delete(`/categories/${activeTab}/${id}`);
      if (data.length === 1 && page > 1) {
        setPage(page - 1);
      } else {
        fetchData();
      }
    } catch (err) {
      alert("Delete failed.");
      console.error(err);
    }
  };

  const handleOrderChange = async (id, newOrder) => {
    try {
      const order = parseInt(newOrder);
      await axios.put(`/region-order/${id}`, { order });
      fetchData(); // Refresh the table
    } catch (err) {
      console.error("Failed to update order:", err);
      alert("Failed to update order.");
    }
  };

  // const handleEdit = (item) => {
  //   setEditId(item._id);
  //   setFormData({ name: item.name, image: item.image });
  //   setIsModalOpen(true);
  // };
  const handleEdit = (item) => {
    setEditId(item._id);
    setFormData({ name: item.name, image: item.image, order: item.order || 0 }); // include order
    setIsModalOpen(true);
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   if (!formData.name.trim() || !formData.image.trim()) {
  //     setError("Please fill all fields.");
  //     return;
  //   }
  //   try {
  //     if (editId) {
  //       await axios.put(`/categories/${activeTab}/${editId}`, formData);
  //     } else {
  //       await axios.post(`/categories/${activeTab}`, formData);
  //     }
  //     setIsModalOpen(false);
  //     setFormData({ name: "", image: "" });
  //     setEditId(null);
  //     fetchData();
  //     setError("");
  //   } catch (err) {
  //     setError("Failed to save data.");
  //     console.error(err);
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name.trim() || !formData.image) {
      setError("Please fill all fields.");
      return;
    }
  
    try {
      const payload = new FormData();
      payload.append("name", formData.name);
      payload.append("image", formData.image);
  
      if (editId) {
        await axios.put(`/categories/${activeTab}/${editId}`, payload, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      } else {
        await axios.post(`/categories/${activeTab}`, payload, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      }
  
      setIsModalOpen(false);
      setFormData({ name: "", image: "" });
      setEditId(null);
      fetchData();
      setError("");
    } catch (err) {
      setError("Failed to save data.");
      console.error(err);
    }
  };

  return (
    <div className="max-w-7xl mx-auto py-2 px-2 bg-gray-50">
      <p className="text-2xl font-extrabold  text-blue-600 mb-10 tracking-tight">
        Manage{" "}
        <span className="text-indigo-600">
          {activeTab === "category" ? "Categories" : "Regions"}
        </span>
      </p>

      {/* Tabs */}
      <div className="flex mb-8 space-x-6">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={clsx(
              "flex items-center space-x-2 px-4 py-2 rounded-full font-semibold text-s transition duration-300",
              activeTab === tab.key
                ? "bg-indigo-600 text-white shadow-lg"
                : "bg-gray-100 text-gray-700 hover:bg-gray-200"
            )}
          >
            <span>{tab.icon}</span>
            <span>{tab.label}</span>
          </button>
        ))}
      </div>

      {/* Add Button */}
      <div className="flex justify-end mb-6">
        <button
          onClick={() => {
            setIsModalOpen(true);
            setFormData({ name: "", image: "" });
            setEditId(null);
            setError("");
          }}
          className="inline-flex items-center gap-2 px-5 py-3 bg-indigo-600 text-white rounded-lg shadow-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-400 transition"
        >
          <FaPlus />
          Add {activeTab === "category" ? "Category" : "Region"}
        </button>
      </div>

      {/* Table */}
      <div className="overflow-x-auto bg-white rounded-lg shadow-lg p-6 border border-gray-200">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-indigo-50">
            <tr>
              <th className="px-4 py-3 text-center text-xs font-bold text-indigo-600 uppercase tracking-wide w-16">
                Sr No.
              </th>
              <th className="px-6 py-3 text-left text-xs font-bold text-indigo-600 uppercase tracking-wide">
                Name
              </th>
              <th className="px-6 py-3 text-left text-xs font-bold text-indigo-600 uppercase tracking-wide">
                Image
              </th>
              {activeTab === "country" && (
                <th className="px-6 py-3 text-left text-xs font-bold text-indigo-600 uppercase tracking-wide">
                  Order
                </th>
              )}
              <th className="px-6 py-3 text-center text-xs font-bold text-indigo-600 uppercase tracking-wide">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {isLoading ? (
              <tr>
                <td
                  colSpan={4}
                  className="text-center py-8 text-gray-400 italic"
                >
                  Loading...
                </td>
              </tr>
            ) : data.length > 0 ? (
              data.map((item, index) => (
                <tr key={item._id} className="hover:bg-indigo-50 transition">
                  <td className="px-4 py-4 text-center text-gray-800 font-medium">
                    {(page - 1) * ITEMS_PER_PAGE + index + 1}
                  </td>
                  <td className="px-6 py-4 text-gray-800 font-medium">
                    {item.name}
                  </td>
                  <td className="px-6 py-4">
                    <img
                      src={item.image}
                      alt={item.name}
                      className="h-14 w-20 rounded-md object-cover border border-gray-300 shadow-sm"
                      loading="lazy"
                    />
                  </td>
                  {activeTab === "country" && (
  <td className="px-6 py-4">
    <select
      value={item.order}
      onChange={(e) =>
        handleOrderChange(item._id, e.target.value)
      }
      className="border border-gray-300 rounded px-2 py-1 w-24 bg-white"
    >
      <option value="">Select</option>
      {[1, 2, 3, 4, 5, 6].map((num) => (
        <option key={num} value={num}>
          {num}
        </option>
      ))}
    </select>
  </td>
)}
                  <td className="px-6 py-4 text-center space-x-4">
                    <button
                      onClick={() => handleEdit(item)}
                      className="text-indigo-600 hover:text-indigo-800 text-lg"
                      aria-label="Edit"
                      title="Edit"
                    >
                      <FaEdit />
                    </button>
                    <button
                      onClick={() => handleDelete(item._id)}
                      className="text-red-600 hover:text-red-800 text-lg"
                      aria-label="Delete"
                      title="Delete"
                    >
                      <FaTrash />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={4}
                  className="text-center py-8 text-gray-500 italic"
                >
                  No data available.
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {/* Pagination */}
        <div className="flex justify-between items-center mt-6">
          <button
            onClick={() => setPage((p) => Math.max(1, p - 1))}
            disabled={page === 1}
            className={clsx(
              "flex items-center gap-2 px-4 py-2 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed transition"
            )}
          >
            <FaChevronLeft />
            Previous
          </button>

          <span className="text-gray-700 font-semibold">
            Page {page} of {totalPages}
          </span>

          <button
            onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
            disabled={page === totalPages}
            className={clsx(
              "flex items-center gap-2 px-4 py-2 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed transition"
            )}
          >
            Next
            <FaChevronRight />
          </button>
        </div>
      </div>

      {/* Modal */}
      <Dialog
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        className="fixed inset-0 z-50 overflow-y-auto"
      >
        <div className="flex items-center justify-center min-h-screen px-4">
          <Dialog.Overlay className="fixed inset-0 bg-black opacity-40" />

          <div className="relative bg-white rounded-lg max-w-lg w-full p-8 shadow-xl z-60">
            <Dialog.Title className="text-2xl font-extrabold mb-6 text-indigo-600">
              {editId ? "Edit" : "Add"}{" "}
              {activeTab === "category" ? "Category" : "Region"}
            </Dialog.Title>

            {error && (
              <div className="mb-4 p-3 bg-red-100 text-red-700 rounded text-center font-semibold">
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label
                  className="block text-gray-700 font-medium mb-2"
                  htmlFor="name"
                >
                  Name
                </label>
                <input
                  id="name"
                  type="text"
                  value={formData.name}
                  onChange={(e) =>
                    setFormData({ ...formData, name: e.target.value })
                  }
                  required
                  className="w-full border border-gray-300 rounded-md px-4 py-3 focus:outline-none focus:ring-2 focus:ring-indigo-500 transition"
                  placeholder={`Enter ${
                    activeTab === "category" ? "category" : "region"
                  } name`}
                />
              </div>
              <div>
                <label
                  className="block text-gray-700 font-medium mb-2"
                  htmlFor="image"
                >
                  Image URL
                </label>
                {/* <input
                  id="image"
                  type="url"
                  value={formData.image}
                  onChange={(e) =>
                    setFormData({ ...formData, image: e.target.value })
                  }
                  required
                  className="w-full border border-gray-300 rounded-md px-4 py-3 focus:outline-none focus:ring-2 focus:ring-indigo-500 transition"
                  placeholder="Enter image URL"
                /> */}
                <input
  id="image"
  type="file"
  accept="image/*"
  onChange={(e) => setFormData({ ...formData, image: e.target.files[0] })}
  required
/>

              </div>

              <div className="flex justify-end space-x-4 mt-6">
                <button
                  type="button"
                  onClick={() => setIsModalOpen(false)}
                  className="px-6 py-3 rounded-md bg-gray-300 hover:bg-gray-400 font-semibold transition"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-6 py-3 rounded-md bg-indigo-600 hover:bg-indigo-700 text-white font-semibold transition"
                >
                  {editId ? "Update" : "Add"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default AdminCategoryCountry;
// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import {
//   FaEdit,
//   FaTrash,
//   FaPlus,
//   FaTags,
//   FaGlobeAmericas,
//   FaChevronLeft,
//   FaChevronRight,
// } from "react-icons/fa";
// import { Dialog } from "@headlessui/react";
// import clsx from "clsx";

// const TABS = [
//   { key: "category", label: "Categories", icon: <FaTags size={18} /> },
//   { key: "country", label: "Regions / Countries", icon: <FaGlobeAmericas size={18} /> },
// ];

// const ITEMS_PER_PAGE = 5;

// const AdminCategoryCountry = () => {
//   const [activeTab, setActiveTab] = useState("category");
//   const [data, setData] = useState([]);
//   const [page, setPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [isLoading, setIsLoading] = useState(false);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [formData, setFormData] = useState({ name: "", image: "" });
//   const [editId, setEditId] = useState(null);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     setPage(1); // reset page on tab change
//   }, [activeTab]);

//   useEffect(() => {
//     fetchData();
//   }, [activeTab, page]);

//   const fetchData = async () => {
//     setIsLoading(true);
//     setError("");
//     try {
//       const res = await axios.get(`/categories/${activeTab}?page=${page}&limit=${ITEMS_PER_PAGE}`);
//       setData(res.data.data);
//       setTotalPages(res.data.totalPages);
//     } catch (err) {
//       setError("Failed to load data.");
//       console.error(err);
//     }
//     setIsLoading(false);
//   };

//   const handleDelete = async (id) => {
//     if (!window.confirm("Are you sure you want to delete this item?")) return;
//     try {
//       await axios.delete(`/categories/${activeTab}/${id}`);
//       // If deleting last item on page, go back a page if possible
//       if (data.length === 1 && page > 1) {
//         setPage(page - 1);
//       } else {
//         fetchData();
//       }
//     } catch (err) {
//       alert("Delete failed.");
//       console.error(err);
//     }
//   };

//   const handleEdit = (item) => {
//     setEditId(item._id);
//     setFormData({ name: item.name, image: item.image });
//     setIsModalOpen(true);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!formData.name.trim() || !formData.image.trim()) {
//       setError("Please fill all fields.");
//       return;
//     }
//     try {
//       if (editId) {
//         await axios.put(`/categories/${activeTab}/${editId}`, formData);
//       } else {
//         await axios.post(`/categories/${activeTab}`, formData);
//       }
//       setIsModalOpen(false);
//       setFormData({ name: "", image: "" });
//       setEditId(null);
//       fetchData();
//       setError("");
//     } catch (err) {
//       setError("Failed to save data.");
//       console.error(err);
//     }
//   };

//   return (
//     <div className="max-w-7xl mx-auto py-10 px-6">
//       <h2 className="text-4xl font-extrabold text-center text-gray-900 mb-10 tracking-tight">
//         Manage <span className="text-blue-600">{activeTab === "category" ? "Categories" : "Regions"}</span>
//       </h2>

//       {/* Tabs */}
//       <div className="flex justify-center mb-8 space-x-6">
//         {TABS.map((tab) => (
//           <button
//             key={tab.key}
//             onClick={() => setActiveTab(tab.key)}
//             className={clsx(
//               "flex items-center space-x-2 px-6 py-3 rounded-full font-semibold text-lg transition-shadow duration-300",
//               activeTab === tab.key
//                 ? "bg-blue-600 text-white shadow-lg"
//                 : "bg-gray-100 text-gray-700 hover:bg-gray-200"
//             )}
//           >
//             <span>{tab.icon}</span>
//             <span>{tab.label}</span>
//           </button>
//         ))}
//       </div>

//       {/* Add Button */}
//       <div className="flex justify-end mb-6">
//         <button
//           onClick={() => {
//             setIsModalOpen(true);
//             setFormData({ name: "", image: "" });
//             setEditId(null);
//             setError("");
//           }}
//           className="inline-flex items-center gap-2 px-5 py-3 bg-blue-600 text-white rounded-lg shadow-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
//         >
//           <FaPlus />
//           Add {activeTab === "category" ? "Category" : "Region"}
//         </button>
//       </div>

//       {/* Table */}
//       <div className="overflow-x-auto bg-white rounded-lg shadow-lg p-6 border border-gray-200">
//         <table className="min-w-full divide-y divide-gray-200">
//           <thead className="bg-gray-50">
//             <tr>
//               <th className="px-6 py-3 text-left text-xs font-bold text-gray-500 uppercase tracking-wide">Name</th>
//               <th className="px-6 py-3 text-left text-xs font-bold text-gray-500 uppercase tracking-wide">Image</th>
//               <th className="px-6 py-3 text-center text-xs font-bold text-gray-500 uppercase tracking-wide">Actions</th>
//             </tr>
//           </thead>
//           <tbody className="divide-y divide-gray-100">
//             {isLoading ? (
//               <tr>
//                 <td colSpan={3} className="text-center py-8 text-gray-400 italic">
//                   Loading...
//                 </td>
//               </tr>
//             ) : data.length > 0 ? (
//               data.map((item) => (
//                 <tr key={item._id} className="hover:bg-blue-50 transition">
//                   <td className="px-6 py-4 text-gray-800 font-medium">{item.name}</td>
//                   <td className="px-6 py-4">
//                     <img
//                       src={item.image}
//                       alt={item.name}
//                       className="h-14 w-20 rounded-md object-cover border border-gray-300 shadow-sm"
//                       loading="lazy"
//                     />
//                   </td>
//                   <td className="px-6 py-4 text-center space-x-4">
//                     <button
//                       onClick={() => handleEdit(item)}
//                       className="text-blue-600 hover:text-blue-800 text-lg"
//                       aria-label="Edit"
//                       title="Edit"
//                     >
//                       <FaEdit />
//                     </button>
//                     <button
//                       onClick={() => handleDelete(item._id)}
//                       className="text-red-600 hover:text-red-800 text-lg"
//                       aria-label="Delete"
//                       title="Delete"
//                     >
//                       <FaTrash />
//                     </button>
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan={3} className="text-center py-8 text-gray-500 italic">
//                   No data available.
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>

//         {/* Pagination */}
//         <div className="flex justify-between items-center mt-6">
//           <button
//             onClick={() => setPage((p) => Math.max(1, p - 1))}
//             disabled={page === 1}
//             className={clsx(
//               "flex items-center gap-2 px-4 py-2 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed transition"
//             )}
//           >
//             <FaChevronLeft />
//             Previous
//           </button>

//           <span className="text-gray-700 font-semibold">
//             Page {page} of {totalPages}
//           </span>

//           <button
//             onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
//             disabled={page === totalPages}
//             className={clsx(
//               "flex items-center gap-2 px-4 py-2 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed transition"
//             )}
//           >
//             Next
//             <FaChevronRight />
//           </button>
//         </div>
//       </div>

//       {/* Modal */}
//       <Dialog
//         open={isModalOpen}
//         onClose={() => setIsModalOpen(false)}
//         className="fixed inset-0 z-50 overflow-y-auto"
//       >
//         <div className="flex items-center justify-center min-h-screen px-4">
//           <Dialog.Overlay className="fixed inset-0 bg-black opacity-40" />

//           <div className="relative bg-white rounded-lg max-w-lg w-full p-8 shadow-2xl z-60">
//             <Dialog.Title className="text-2xl font-extrabold mb-6 text-gray-900">
//               {editId ? "Edit" : "Add"} {activeTab === "category" ? "Category" : "Region"}
//             </Dialog.Title>

//             {error && (
//               <div className="mb-4 p-3 bg-red-100 text-red-700 rounded text-center font-semibold">
//                 {error}
//               </div>
//             )}

//             <form onSubmit={handleSubmit} className="space-y-6">
//               <div>
//                 <label className="block text-gray-700 font-medium mb-2" htmlFor="name">
//                   Name
//                 </label>
//                 <input
//                   id="name"
//                   type="text"
//                   value={formData.name}
//                   onChange={(e) => setFormData({ ...formData, name: e.target.value })}
//                   required
//                   className="w-full border border-gray-300 rounded-md px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
//                   placeholder={`Enter ${activeTab === "category" ? "category" : "region"} name`}
//                 />
//               </div>
//               <div>
//                 <label className="block text-gray-700 font-medium mb-2" htmlFor="image">
//                   Image URL
//                 </label>
//                 <input
//                   id="image"
//                   type="url"
//                   value={formData.image}
//                   onChange={(e) => setFormData({ ...formData, image: e.target.value })}
//                   required
//                   className="w-full border border-gray-300 rounded-md px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
//                   placeholder="Enter image URL"
//                 />
//               </div>

//               <div className="flex justify-end space-x-4 mt-6">
//                 <button
//                   type="button"
//                   onClick={() => setIsModalOpen(false)}
//                   className="px-6 py-3 rounded-md bg-gray-300 hover:bg-gray-400 font-semibold transition"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="submit"
//                   className="px-6 py-3 rounded-md bg-blue-600 hover:bg-blue-700 text-white font-semibold transition"
//                 >
//                   {editId ? "Update" : "Add"}
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       </Dialog>
//     </div>
//   );
// };

// export default AdminCategoryCountry;
